<template>
  <p>GDPR</p>
</template>

<script>
export default {
  name: "GDPR"
};
</script>

<style scoped></style>
